import * as Rx from "rxjs";
import * as RxOp from "rxjs/operators";
import * as S from "sanctuary";
import type { Either } from "sanctuary";

interface RequestEpicOptions<Args, T, Action> {
  requestMethod: (args: Args) => Rx.ObservableInput<Either<Error, T>>;
  requestArgs: Args;
  onSuccess: (result: Either<Error, T>) => Rx.ObservableInput<Action>;
  onFailure: (result: Either<Error, T>) => Rx.ObservableInput<Action>;
}

/**
 * requestEpic
 *
 * Runs a request method, which reads its own service's endpoint, and turns its
 * Either into onFailure's actions for a Left or onSuccess's for a Right, passing
 * each the Either. The request method may return a Promise or an Observable.
 */
export const requestEpic = <Args, T, Action>({
  requestMethod,
  requestArgs,
  onSuccess,
  onFailure,
}: RequestEpicOptions<Args, T, Action>): Rx.Observable<Action> =>
  Rx.from(requestMethod(requestArgs)).pipe(
    RxOp.mergeMap((result) =>
      S.isLeft(result) ? onFailure(result) : onSuccess(result)
    )
  );
